/**
 * @generated SignedSource<<22bb10b3ad2d285c6819c6e526361427>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type VideoDetailsMetadataMutation$variables = {
  id: string;
  metadata: BasicMetadata;
};
export type VideoDetailsMetadataMutation$data = {
  readonly updateEventMetadata: {
    readonly hasActiveWorkflows: boolean;
    readonly id: string;
  };
};
export type VideoDetailsMetadataMutation = {
  response: VideoDetailsMetadataMutation$data;
  variables: VideoDetailsMetadataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metadata"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "AuthorizedEvent",
    "kind": "LinkedField",
    "name": "updateEventMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasActiveWorkflows",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoDetailsMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoDetailsMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e9218609b295bc1c3c7a3a8bd0381507",
    "id": null,
    "metadata": {},
    "name": "VideoDetailsMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation VideoDetailsMetadataMutation(\n  $id: ID!\n  $metadata: BasicMetadata!\n) {\n  updateEventMetadata(id: $id, metadata: $metadata) {\n    id\n    hasActiveWorkflows\n  }\n}\n"
  }
};
})();

(node as any).hash = "05ebc06bb00173a6a35d2d136c9e59da";

export default node;
